import styled from 'styled-components';

const Card = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${({ theme }) => theme.spacing(10, 0)};
  border-bottom: 1px solid ${({ theme }) => theme.colors.platinum};
  margin: ${({ theme }) => theme.spacing(0, 12, 0, 12)};
`;

export default Card;
